import { render, staticRenderFns } from "./ConfirmationLandingPage.vue?vue&type=template&id=bc820cf0&scoped=true"
import script from "./ConfirmationLandingPage.vue?vue&type=script&lang=js"
export * from "./ConfirmationLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationLandingPage.vue?vue&type=style&index=0&id=bc820cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc820cf0",
  null
  
)

export default component.exports